(() => {
  if (customElements.get('product-details-selector')) return;

  const registerProductDetailsSelector = () => {
    const BaseSelector = customElements.get('main-product-selector');

    if (!BaseSelector) return;

    class ProductDetailsSelector extends BaseSelector {
      /**
       * Read only explicitly marked variant controls.
       * Other dropdowns and radio buttons must not affect variants.
       */
      updateOptions() {
        this.options = Array.from(
          this.querySelectorAll(
            'input[type="radio"][data-variant-option]:checked, ' +
            'select[data-variant-option]'
          ),
          (element) => ({
            name: element.dataset.name,
            value: element.value
          })
        );
      }

      /**
       * Ignore changes from unrelated widgets or form fields.
       */
      onVariantChange(event) {
        if (!event.target.matches('[data-variant-option]')) return;

        super.onVariantChange(event);
      }

      /**
       * Keep the configured available-state label after variant changes.
       * Preserve sold-out labels supplied by the existing selector.
       */
      toggleAddButton(disable, text) {
        super.toggleAddButton(disable, text);

        if (!this.submitButton) return;

        if (!disable) {
          const label =
            this.dataset.addToCartLabel ||
            window.variantStrings.addToCart;

          const textWrapper =
            this.submitButton.querySelector('span') ||
            this.submitButton;

          textWrapper.textContent = label;
        }

        this.syncStickyButton();
      }

      /**
       * Mirror unavailable state to the sticky purchase button.
       */
      setUnavailable() {
        super.setUnavailable();
        this.syncStickyButton();
      }

      /**
       * Keep sticky button text and disabled state in sync.
       */
      syncStickyButton() {
        if (!this.submitButton) return;

        const mainTextWrapper =
          this.submitButton.querySelector('span') ||
          this.submitButton;

        this.querySelectorAll('[data-sticky-add]').forEach((button) => {
          const stickyTextWrapper =
            button.querySelector('span') || button;

          stickyTextWrapper.textContent = mainTextWrapper.textContent;
          button.disabled = this.submitButton.disabled;
        });
      }

      /**
       * Scope media updates to this product section.
       */
      updateMedia() {
        if (!this.currentVariant?.featured_media) return;

        const productMedia =
          this.closest('section')?.querySelector('product-media');

        if (typeof productMedia?.setActiveMedia === 'function') {
          productMedia.setActiveMedia(
            this.currentVariant.featured_media.id
          );
        }
      }
    }

    customElements.define(
      'product-details-selector',
      ProductDetailsSelector
    );
  };

  customElements
    .whenDefined('main-product-selector')
    .then(registerProductDetailsSelector);
})();
